/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Calendar.css';
import moment from 'moment'
import range from 'lodash/range'
import chunk from 'lodash/chunk'

var week = [
  'Sun',
  'Mon',
  'Tue',
  'Wed',
  'Thu',
  'Fri',
  'Sat'
] // en
// const week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
// const timeMonth = [
//   '一月',
//   '二月',
//   '三月',
//   '四月',
//   '五月',
//   '六月',
//   '七月',
//   '八月',
//   '九月',
//   '十月',
//   '十一月',
//   '十二月'
// ]
const timeMonth=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']

class Day extends React.Component {
  render() {
    const {
      i,
      w,
      d,
      now,
      month,
      thisDay,
      select,
      weekDay,
      weekActive,
      weekNum
    } = this.props
    var prevMonth = (w === 0 && i > 7)
    var nextMonth = (w >= 4 && i <= 14)

    let disName
    if (select == 'day') {

      if (prevMonth || nextMonth && now != month) {
        disName = s.otherMonth

      } else if (i > thisDay && now == month || now == month && nextMonth) {
        // 明天之后的日期
        // disName = s.visiDay
      } else if (!prevMonth && !nextMonth && (i === d)) {
        disName = s.currentDay
      } else {
        disName = s.currentMonth
      }
    } else if (select == 'week') {
      // console.log(i+'周'+weekDay)
      if (prevMonth || nextMonth) {
        disName = s.otherMonth
      } else if (i > thisDay && now == month || now == month && nextMonth) {
        // 明天之后的日期
        // disName = s.visiDay
      } else if (weekActive == 0 && weekNum == 0) {
        if (w == 0 && weekDay == 0) {
          disName = s.weekSelect
        }
      } else if (weekActive == 5 && weekNum > 0) {
        if (w == 5 && weekDay > 0) {
          disName = s.weekSelect
        }
      } else if (weekNum != 0) {
        if (w == (weekActive + 1) && weekDay == 0 || w == weekActive & weekDay > 0) {
          disName = s.weekSelect
        }
      } else if (weekNum == 0) {
        if (w == (weekActive) && weekDay == 0 || w == (weekActive - 1) & weekDay > 0) {
          disName = s.weekSelect
        }
      }

    }

    return <td
      onClick={this.props.onClick}
      onMouseEnter={this.props.onMouseEnter}
      className={disName}>{i}</td>
  }
}

class Calendar extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      m: moment(),
      monthIndex: moment().format('MMM'),
      weekActive: null,
      weekNum: null
    }
    this.prevMonth = this
      .prevMonth
      .bind(this)
    this.nextMonth = this
      .nextMonth
      .bind(this)
    this.prevYear = this
      .prevYear
      .bind(this)
    this.nextYear = this
      .nextYear
      .bind(this)
    this.selectDate = this
      .selectDate
      .bind(this)
    this.selectMonth = this
      .selectMonth
      .bind(this)
    this.selectWeek = this
      .selectWeek
      .bind(this)
    this.calendarMonth = this
      .calendarMonth
      .bind(this)
    this.calendarDay = this
      .calendarDay
      .bind(this)
    this.calendarWeek = this
      .calendarWeek
      .bind(this)
    this.mouseEnter = this
      .mouseEnter
      .bind(this)
  }
  componentDidMount() {
    // if(moment().format('a')=='pm'){   this.setState({m:moment()}) }
  }
  mouseEnter = (w, i) => {
    // console.log(w)
    this.setState({weekActive: w, weekNum: i})
  }
  calendarWeek(days, d, m) {

    let thisDay
    if (moment().format('a') == 'pm') {
      thisDay = moment()
        .subtract(1, 'days')
        .format('DD')
    } else {
      thisDay = moment()
        .subtract(2, 'days')
        .format('DD')
    }

    return (
      <table>
        <thead>
          <tr>
            {week.map((w, i) => <th key={i}>{w}</th>)}
          </tr>
        </thead>
        <tbody>
          {chunk(days, 7).map((row, w) => (
            <tr key={w}>
              {row.map((i, index) => (<Day
                key={i}
                i={i}
                d={d}
                w={w}
                now={moment().format('YYYY-MM')}
                month={m.format('YYYY-MM')}
                thisDay={thisDay}
                onClick={() => this.selectWeek(i, w)}
                select='week'
                weekDay={index}
                onMouseEnter={() => this.mouseEnter(w, index)}
                weekActive={this.state.weekActive}
                weekNum={this.state.weekNum}/>))}
            </tr>
          ))}

        </tbody>
      </table>
    )
  }

  calendarMonth(i) {
    const monthIndex = i
    return (
      <table>
        <tbody>
          {chunk(timeMonth, 3).map((col, w) => (
            <tr key={w}>
              {col.map((item) => (
                <td
                  key={item}
                  onClick={() => this.selectMonth(item)}
                  className={item == monthIndex
                  ? s.monthAc
                  : ''}>{item}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>

    )
  }
  calendarDay(days, d, m) {
    let thisDay
    if (moment().format('a') == 'pm') {
      thisDay = moment()
        .subtract(1, 'days')
        .format('DD')
    } else {
      thisDay = moment()
        .subtract(2, 'days')
        .format('DD')
    }

    return (
      <table>
        <thead>
          <tr>
            {week.map((w, i) => <th key={i}>{w}</th>)}
          </tr>
        </thead>
        <tbody>
          {chunk(days, 7).map((row, w) => (
            <tr key={w}>
              {row.map((i) => (<Day
                key={i}
                i={i}
                d={d}
                w={w}
                now={moment().format('YYYY-MM')}
                month={m.format('YYYY-MM')}
                thisDay={thisDay}
                onClick={() => this.selectDate(i, w)}
                select='day'/>))}
            </tr>
          ))}

        </tbody>
      </table>
    )
  }

  selectMonth(i) {
    this.setState({
      monthIndex: i,
      m: this
        .state
        .m
        .month(i)
    })
    // console.log(this.state.m)
    let time = this
      .state
      .m
      .format('YYYY-MM')
    this
      .props
      .close(time)
  }
  selectWeek(i, w) {
    const m = this.state.m
    var prevMonth = (w === 0 && i > 7)
    var nextMonth = (w >= 4 && i <= 14)

    console.log(i, moment().format('YYYY-MM-DD'))
    let time

    if (prevMonth && nextMonth) {
      // m.subtract(1, 'month') this.setState({m:m.subtract(1,'month')})
    } else if (nextMonth && m.format('YYYY-MM') < moment().format('YYYY-MM')) {
      // m.add(1, 'month') this.setState({m:this.state.m.add(1,'month')})

    } else if (i > moment().format('YYYY-MM-DD')) {
      console.log()
    } else if (!prevMonth && !nextMonth && i <= moment().format('DD') && m.format('YYYY-MM') == moment().format('YYYY-MM') || !prevMonth && !nextMonth && m.format('YYYY-MM') != moment().format('YYYY-MM')) {
      // console.log('keyidianji')
      m.date(i)

      this.setState({
        m: this.state.m,
        monthIndex: m.format('MMM')
      })
      if (this.state.weekNum == 0) {
        time = this
          .state
          .m
          .day(-6)
          .format('YYYY-MM-DD') + ' 至 ' + this
          .state
          .m
          .day(7)
          .format('YYYY-MM-DD')
      } else {
        time = this
          .state
          .m
          .day(1)
          .format('YYYY-MM-DD') + ' 至 ' + this
          .state
          .m
          .day(7)
          .format('YYYY-MM-DD')
      }
      this
        .props
        .close(time)

    }

  }
  selectDate(i, w) {
    const m = this.state.m
    // console.log(m().format(), i,w)
    var prevMonth = (w === 0 && i > 7)
    var nextMonth = (w >= 4 && i <= 14)
    const nowMonth = (m.format('YYYY-MM') == moment().format('YYYY-MM'))
    const tomorrow = (i > moment().subtract(1, 'days').format('DD'))
    // var m = this.props.moment let sj=m console.log(sj().date(),sj().subtract(1,
    // 'days'),sj().add(1,'days'),sj().date()) const thisDay
    m.date(i)
    if (prevMonth) {
      // m.subtract(1, 'month')
      this.setState({
        m: m.subtract(1, 'month')
      })
    } else if (nextMonth && m.format('YYYY-MM') < moment().format('YYYY-MM')) {
      // m.add(1, 'month')
      this.setState({
        m: this
          .state
          .m
          .add(1, 'month')
      })

    }
    //  else if (nowMonth && nextMonth || nowMonth && tomorrow) {
    //   // console.log('选择任意时间')
    // }
     else {

      this.setState({
        m: this.state.m,
        monthIndex: m.format('MMM')
      })

      let time = this
        .state
        .m
        .format('YYYY-MM-DD')
      this
        .props
        .close(time)
    }

  }

  prevYear() {
    this.setState({
      m: this
        .state
        .m
        .subtract(1, 'year')
    })
  }
  nextYear() {
  
    const {hasMore}=this.props
    if (this.state.m.format('YYYY') < moment().format('YYYY')) {

      this.setState({
        m: this
          .state
          .m
          .add(1, 'year')
      })
    }

    if(hasMore){
      this.setState({
        m:this.state.m.add(1,'year'),
      })
    }

  }

  prevMonth() {
    // e.preventDefault() console.log(days)
    const m = this.state.m

    this.setState({
      m: this
        .state
        .m
        .subtract(1, 'month'),
      monthIndex: m.format('MMM')
    })
  }
  nextMonth() {
    const m = this.state.m
    const {hasMore} = this.props

    if (this.state.m.format('YYYY-MM') < moment().format('YYYY-MM')) {

      this.setState({
        m: this
          .state
          .m
          .add(1, 'month'),
        monthIndex: m.format('MMM')
      })
    }
    if(hasMore){
      this.setState({
        m: this
          .state
          .m
          .add(1, 'month'),
        monthIndex: m.format('MMM')
      })
    }

  }

  render() {
    const {m, monthIndex} = this.state
    const {cycle,otherlayout,hasmore} = this.props
    // let m=this.state.m

    let d = m.date()
    let d1 = m.clone().subtract(1, 'month').endOf('month').date()
    let d2 = m.clone().date(1).day()
    let d3 = m
      .clone()
      .endOf('month')
      .date()

    let days = [].concat(range(d1 - d2 + 1, d1 + 1), range(1, d3 + 1), range(1, 42 - d3 - d2 + 1))

    // console.log(monthIndex)
    const renderCalendar = () => {
      // console.log(cycle)
      if (cycle == '日榜') {

        return this.calendarDay(days, d, m)

      } else if (cycle == '周榜') {

        return this.calendarWeek(days, d, m)
      } else {

        return this.calendarMonth(monthIndex)
      }
    }

    return (
      <div className={this.props.isShow
        ? s.show
        : s.hide}
        onMouseEnter={this.props.en}
        onMouseLeave={this.props.ov}
        >
        <div className={s.model}>

          <div className={s.calendar} style={{'left':otherlayout?'0px':null,'right':otherlayout?null:'0px'}}>
            <div className={s.calendarHead}>

              <div className={s.yaerChoose}>
                <span className={s.prev} onClick={this.prevYear}></span>
                <span id="yearGet">{m.format('YYYY')}</span>
                <span className={s.next} onClick={this.nextYear}></span>
              </div>
              <div className={s.dayChoose}>
                <span className={s.prev} onClick={this.prevMonth}></span>
                <span id="dayGet">{m.format('MM')}</span>
                <span className={s.next} onClick={this.nextMonth}></span>
              </div>
            </div>
            <div className={s.calendarTable} id="calendarBody">
              {renderCalendar()}
            </div>
          </div>
        </div>

      </div>
    )

  }
}

export default withStyles(s)(Calendar);



// WEBPACK FOOTER //
// src/components/Calendar/Calendar.js